import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal';
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { employeeListRequest } from '../../../redux/employee/employee.action'
import {
    auditDetailRequest, auditAddLogCommentRequest, auditAddLogCommentRequestStatus,
    auditAddLogRequest, auditAddLogRequestStatus, auditAssignUserRequest, auditAssignUserRequestStatus,
    auditUpdateLogStatusRequest, auditUpdateLogStatusRequestStatus, auditUpdateStatusRequest,
    auditUpdateStatusRequestStatus
} from '../../../redux/audit/audit.action'
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import moment from "moment";

const AuditDetail = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { state } = useLocation()
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState()
    const [selectedLogStatus, setSelectedLogStatus] = useState()
    let STATUS_LIST = [
        { key: APP_CONSTANTS.AUDIT_STATUS.NEW, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.AUDIT_STATUS.NEW) },
        { key: APP_CONSTANTS.AUDIT_STATUS.PENDING, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.AUDIT_STATUS.PENDING) },
        { key: APP_CONSTANTS.AUDIT_STATUS.IN_PROCESS, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.AUDIT_STATUS.IN_PROCESS) },
        { key: APP_CONSTANTS.AUDIT_STATUS.COMPLETED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.AUDIT_STATUS.COMPLETED) },
        { key: APP_CONSTANTS.AUDIT_STATUS.ON_HOLD, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.AUDIT_STATUS.ON_HOLD) },
    ]
    let LOG_STATUS_LIST = [
        { key: APP_CONSTANTS.AUDIT_LOG_STATUS.APPROVED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.AUDIT_LOG_STATUS.APPROVED) },
        { key: APP_CONSTANTS.AUDIT_LOG_STATUS.CANCELLED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.AUDIT_LOG_STATUS.CANCELLED) }
    ]
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const { auditDetailSuccess, auditDetailError, assignAuditSuccess,
        assignAuditError, assignAuditReqStatus, updateAuditStatusSuccess,
        updateAuditStatusError, updateAuditStatusReqStatus, auditAddLogSuccess,
        auditAddLogError, auditAddLogReqStatus, auditUpdateLogStatusSuccess,
        auditUpdateLogStatusError, auditUpdateLogStatusReqStatus, auditAddLogCommentSuccess,
        auditAddLogCommentError, auditAddLogCommentReqStatus } = useSelector(state => state.audit)
    const [assignEmployeeModal, setShowAssignEmployeeModal] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [isAssigneeSelection, setIsAssigneeSelection] = useState(false)
    const [isVerifierSelection, setIsVerifierSelection] = useState(false)
    const [auditLog, setAuditLog] = useState('')
    const [showAddLogModal, setShowAddLogModal] = useState(false)
    const [selectedLogItem, setSelectedLogItem] = useState(null)
    const [showUpdateLogItemStatus, setShowUpdateLogItemStatus] = useState(false)
    const [selectedLogRow, setSelectedLogRow] = useState('')
    const [comment, setComment] = useState('')

    useEffect(() => {
        fetchAuditDetails()
    }, [])

    const fetchAuditDetails = () => {
        setLoading(true)
        const data = {
            id: state.auditId,
            params: {
                businessId: state.businessId,
                locationId: state.locationId
            }
        }
        dispatch(auditDetailRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(auditDetailSuccess)) {
            setLoading(false)
        } else if (!isEmpty(auditDetailError)) {
            setLoading(false)
        }
    }, [auditDetailSuccess, auditDetailError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (assignAuditReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(assignAuditSuccess.data?.message)
            fetchAuditDetails()
        } else if (assignAuditReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(assignAuditError.message)
        }
        if (assignAuditReqStatus?.length) {
            dispatch(auditAssignUserRequestStatus(''))
        }
    }, [assignAuditSuccess, assignAuditError, assignAuditReqStatus])

    useEffect(() => {
        if (updateAuditStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateAuditStatusSuccess.data?.message)
            fetchAuditDetails()
        } else if (updateAuditStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateAuditStatusError.message)
        }
        if (updateAuditStatusReqStatus?.length) {
            dispatch(auditUpdateStatusRequestStatus(''))
        }
    }, [updateAuditStatusSuccess, updateAuditStatusError, updateAuditStatusReqStatus])

    useEffect(() => {
        if (auditAddLogReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(auditAddLogSuccess.data?.message)
            fetchAuditDetails()
        } else if (auditAddLogReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(auditAddLogError.message)
        }
        if (auditAddLogReqStatus?.length) {
            dispatch(auditAddLogRequestStatus(''))
        }
    }, [auditAddLogSuccess, auditAddLogError, auditAddLogReqStatus])

    useEffect(() => {
        if (auditUpdateLogStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(auditUpdateLogStatusSuccess.data?.message)
            fetchAuditDetails()
        } else if (auditUpdateLogStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(auditUpdateLogStatusError.message)
        }
        if (auditUpdateLogStatusReqStatus?.length) {
            dispatch(auditUpdateLogStatusRequestStatus(''))
        }
    }, [auditUpdateLogStatusSuccess, auditUpdateLogStatusError, auditUpdateLogStatusReqStatus])

    useEffect(() => {
        if (auditAddLogCommentReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(auditAddLogCommentSuccess.data?.message)
            fetchAuditDetails()
            setComment('')
            setSelectedLogRow('')
        } else if (auditAddLogCommentReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(auditAddLogCommentError.message)
        }
        if (auditAddLogCommentReqStatus?.length) {
            dispatch(auditAddLogCommentRequestStatus(''))
        }
    }, [auditAddLogCommentSuccess, auditAddLogCommentError, auditAddLogCommentReqStatus])

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.AUDIT.ASSIGN_AUDIT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.AUDIT, PERMISSION_SUB_TYPE.AUDIT.ASSIGN_AUDIT, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.AUDIT.UPDATE_AUDIT_STATUS) {
            return checkFunctionalityPermission(user, PERMISSION_SUB_TYPE.AUDIT, PERMISSION_SUB_TYPE.AUDIT.UPDATE_AUDIT_STATUS, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const getStatusClassname = (status) => {
        if (status === APP_CONSTANTS.AUDIT_STATUS.NEW) {
            return 'pd-status-container pd-status-container-new'
        } else if (status === APP_CONSTANTS.AUDIT_STATUS.IN_PROCESS || status === APP_CONSTANTS.AUDIT_STATUS.PENDING || status === APP_CONSTANTS.AUDIT_LOG_STATUS.SUBMITTED) {
            return 'pd-status-container pd-status-container-in-progress'
        } else if (status === APP_CONSTANTS.AUDIT_STATUS.COMPLETED || status === APP_CONSTANTS.AUDIT_LOG_STATUS.APPROVED) {
            return 'pd-status-container pd-status-container-complete'
        } else if (status === APP_CONSTANTS.AUDIT_STATUS.ON_HOLD || status === APP_CONSTANTS.AUDIT_LOG_STATUS.CANCELLED) {
            return 'pd-status-container pd-status-container-cancelled'
        }
    }

    const handleAssignAuditClick = () => {
        setIsAssigneeSelection(true)
        setIsVerifierSelection(false)
        setShowAssignEmployeeModal(true)
    }

    const handleAssignVerifierClick = () => {
        setIsAssigneeSelection(false)
        setIsVerifierSelection(true)
        setShowAssignEmployeeModal(true)
    }

    const handleAssignEmpSubmitClick = (isAssignToMe = false) => {
        if (!isAssignToMe && isEmpty(selectedEmployee)) {
            displayErrorToast('Employee not selected')
        } else if (isEmpty(auditDetailSuccess)) {
            displayErrorToast('Audit details not found. Please try again')
        } else {
            let userId
            let userType
            if (isAssignToMe) {
                if (isLoggedInUserBusiness(user)) {
                    userId = user.data.userDetails.userId
                    userType = user.data.userDetails.userType
                } else {
                    userId = user.data.userDetails.employeeId
                    userType = user.data.userDetails.userType
                }
            } else {
                userId = selectedEmployee.employeeId
                userType = selectedEmployee.userType
            }
            setLoading(true)
            const data = {
                auditId: state.auditId,
                assignorId: isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId,
                assignorUserType: user.data.userDetails.userType,
            }
            if (isAssigneeSelection) {
                data.id = userId
                data.userType = userType
                data.isAssigneeSelection = true
            } else if (isVerifierSelection) {
                data.id = userId
                data.userType = userType
                data.isVerifierSelection = true
            }
            dispatch(auditAssignUserRequest(data))
            setShowAssignEmployeeModal(false)
            setIsAssigneeSelection(false)
            setIsVerifierSelection(false)
        }
    }

    const handleUpdateStatusClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(selectedStatus)) {
            displayErrorToast('Audit status not selected')
        } else {
            setLoading(true)
            const data = {
                auditId: state.auditId,
                status: selectedStatus.key
            }
            dispatch(auditUpdateStatusRequest(data))
            setShowStatusChangeModal(false)
        }
    }

    const handleUpdateLogStatusClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(selectedLogStatus)) {
            displayErrorToast('Log status not selected')
        } else if (isEmpty(selectedLogItem)) {
            displayErrorToast('Log information not available. Please try reselecting log to update status')
        } else {
            setLoading(true)
            const data = {
                auditId: state.auditId,
                status: selectedLogStatus.key,
                logId: selectedLogItem.id
            }
            dispatch(auditUpdateLogStatusRequest(data))
            setShowUpdateLogItemStatus(false)
        }
    }

    const handleAddLogSubmitClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(auditLog)) {
            displayErrorToast('Details cannot be blank')
        } else {
            setLoading(true)
            const data = {
                auditId: state.auditId,
                detail: auditLog,
                sender: `${user.data.userDetails.firstName} ${user.data.userDetails.lastName}`
            }
            dispatch(auditAddLogRequest(data))
            setShowAddLogModal(false)
        }
    }

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {
            businessId: state.businessId,
            locationId: state.locationId
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(employeeListRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(selectedEmployee)) {
            handleAssignEmpSubmitClick(false)
        }
    }, [selectedEmployee])

    const handleLogItemStatusUpdateClick = (item) => {
        setSelectedLogItem(item)
        setShowUpdateLogItemStatus(true)
    }

    const showUpdateLogItemStatusEdit = () => {
        if (state?.flowType !== 'MY_AUDITS') {
            return false
        }
        if (isEmpty(auditDetailSuccess) && isEmpty(auditDetailSuccess.data)) {
            return false
        }
        if (isLoggedInUserBusiness(user)) {
            return true
        }
        let id = user.data.userDetails.employeeId
        let userType = user.data.userDetails.userType
        if (!isEmpty(auditDetailSuccess.data.assigneeUserType) &&
            parseFloat(id) === parseFloat(auditDetailSuccess.data.assigneeId) &&
            userType === auditDetailSuccess.data.assigneeUserType) {
            return true
        }
        if (!isEmpty(auditDetailSuccess.data.assignorUserType) &&
            parseFloat(id) === parseFloat(auditDetailSuccess.data.assignorId) &&
            userType === auditDetailSuccess.data.assignorUserType) {
            return true
        }
        if (!isEmpty(auditDetailSuccess.data.verifierUserType) &&
            parseFloat(id) === parseFloat(auditDetailSuccess.data.verifierId) &&
            userType === auditDetailSuccess.data.verifierUserType) {
            return true
        }
        return false
    }

    const handleCommentSubmitClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(selectedLogRow)) {
            displayErrorToast('Log details not available. Please try refreshing the data.')
        } else if (isEmpty(comment)) {
            displayErrorToast('Comment cannot be blank')
        } else {
            setLoading(true)
            const data = {
                auditId: state.auditId,
                logId: selectedLogRow,
                comment: comment,
                sender: `${user.data.userDetails.firstName} ${user.data.userDetails.lastName}`
            }
            dispatch(auditAddLogCommentRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Audit Details' />
                {!isEmpty(auditDetailSuccess) && <CommonFormBorder>
                    <div className="pd-img-parent-container">
                        <div className="pd-img-container">
                            <img src={require('../../../assets/logo_togethra.png')} className="img" />
                        </div>
                    </div>
                    <div className="pd-status-row-container">
                        <div className={getStatusClassname(auditDetailSuccess.data.status)}>{removeSpecialCharAndChangeToPascal(auditDetailSuccess.data.status)}</div>
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.AUDIT.UPDATE_AUDIT_STATUS) && auditDetailSuccess.data.status !== APP_CONSTANTS.AUDIT_STATUS.COMPLETED && state?.flowType === 'MY_AUDITS' && <div className="ed-role-img-container"
                            onClick={() => { setShowStatusChangeModal(true) }}>
                            <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                        </div>}
                    </div>

                    <div className="pd-name-container">
                        <div className="pd-name-label">{auditDetailSuccess.data.title}</div>
                    </div>
                    <div className="pd-description-container">
                        <div className="pd-description-label">{auditDetailSuccess.data.description}</div>
                    </div>
                    {!isEmpty(auditDetailSuccess.data.type) && <div className="pd-icon-label">Type: {removeSpecialCharAndChangeToPascal(auditDetailSuccess.data.type)}</div>}
                    {!isEmpty(auditDetailSuccess.data.assignorDetails) && <div>
                        <FormFieldLabel label='Assignor Details' />
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_user.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{auditDetailSuccess.data.assignorDetails.firstName} {auditDetailSuccess.data.assignorDetails.lastName}</div>
                        </div>
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-key">{auditDetailSuccess.data.assignorDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? 'Employee Code:' : 'Role Type:'}</div>
                            <div className="pd-icon-label">{auditDetailSuccess.data.assignorDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? auditDetailSuccess.data.assignorDetails.employeeBusinessMapping[0].employeeCode : removeSpecialCharAndChangeToPascal(auditDetailSuccess.data.assignorDetails.userType)}</div>
                        </div>
                    </div>}
                    {!isEmpty(auditDetailSuccess.data.assigneeDetails) && <div className="ad-row-parent-container">
                        <FormFieldLabel label='Assignee Details' />
                        <div className="ad-row-container">
                            {auditDetailSuccess.data.assigneeDetails.map(itm => (<div className="ad-row-item-container">
                                <div className="ad-row-item-name">{itm.firstName} {itm.lastName}</div>
                                <div className="ad-row-item-type">{itm.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? `${itm.employeeBusinessMapping[0]?.employeeCode}` : `${removeSpecialCharAndChangeToPascal(itm.userType)}`}</div>
                            </div>))}
                        </div>
                    </div>}
                    {!isEmpty(auditDetailSuccess.data.verifierDetails) && <div className="ad-row-parent-container">
                        <FormFieldLabel label='Verifier Details' />
                        <div className="ad-row-container">
                            {auditDetailSuccess.data.verifierDetails.map(itm => (<div className="ad-row-item-container">
                                <div className="ad-row-item-name">{itm.firstName} {itm.lastName}</div>
                                <div className="ad-row-item-type">{itm.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? `${itm.employeeBusinessMapping[0]?.employeeCode}` : `${removeSpecialCharAndChangeToPascal(itm.userType)}`}</div>
                            </div>))}
                        </div>
                    </div>}
                    {/* {!isEmpty(auditDetailSuccess.data.verifierDetails) && <div>
                        <FormFieldLabel label='Verifier Details' />
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_user.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{auditDetailSuccess.data.verifierDetails.firstName} {auditDetailSuccess.data.verifierDetails.lastName}</div>
                        </div>
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-key">{auditDetailSuccess.data.verifierDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? 'Employee Code:' : 'Role Type:'}</div>
                            <div className="pd-icon-label">{auditDetailSuccess.data.verifierDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? auditDetailSuccess.data.verifierDetails.employeeBusinessMapping[0].employeeCode : removeSpecialCharAndChangeToPascal(auditDetailSuccess.data.verifierDetails.userType)}</div>
                        </div>
                    </div>} */}
                    <FormFieldLabel className='up-bold-label' label='Logs' />
                    {isEmpty(auditDetailSuccess.data.logs) && <div className="content-error">No Logs added</div>}
                    {!isEmpty(auditDetailSuccess.data.logs) && <div className="td-comment-col-container">
                        {auditDetailSuccess.data.logs.map(item => (<div className="td-comment-item-container" key={item.id}>
                            <div className="pd-status-row-container">
                                <div className={getStatusClassname(item.status)}>{removeSpecialCharAndChangeToPascal(item.status)}</div>
                                {showUpdateLogItemStatusEdit() && item.status === APP_CONSTANTS.AUDIT_LOG_STATUS.SUBMITTED && <div className="ed-role-img-container"
                                    onClick={() => { handleLogItemStatusUpdateClick(item) }}>
                                    <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                                </div>}
                            </div>
                            <div className="ad-log-date">{moment.utc(item.date).local().format('DD/MM/YYYY')}</div>
                            <div className="ad-log-sender">{item.sender}</div>
                            <div className="ad-log-detail">{item.detail}</div>
                            <FormFieldLabel className='up-bold-label' label='Comments' />
                            <div className="ad-add-comment-btn" onClick={() => {
                                setComment('')
                                if (selectedLogRow === item.id) {
                                    setSelectedLogRow('')
                                } else {
                                    setSelectedLogRow(item.id)
                                }
                            }}>{selectedLogRow === item.id ? 'Cancel' : 'Add Comment'}</div>
                            {selectedLogRow === item.id && <div className="ad-comment-view-container">
                                <CommonInputFloatFull
                                    type='text'
                                    id='comment'
                                    onChange={e => setComment(e.target.value)}
                                    placeholder='Comment'
                                    value={comment}
                                    multiline={true}
                                    rows={2}
                                />
                                <div className="ad-submit-comment-btn" onClick={() => { handleCommentSubmitClick() }}>Submit</div>
                            </div>}
                            {isEmpty(item.comments) && <div className="content-error">No comments yet</div>}
                            {!isEmpty(item.comments) && item.comments.map(itm => (<div className="ad-comment-container">
                                <div className="ad-log-date">{moment.utc(itm.date).local().format('DD/MM/YYYY')}</div>
                                <div className="ad-log-sender">{itm.sender}</div>
                                <div className="ad-log-detail">{itm.comment}</div>
                            </div>))}
                        </div>))}
                    </div>}
                    {isPermissionAllowed(PERMISSION_SUB_TYPE.AUDIT.ASSIGN_AUDIT) && <ButtonRow isVertical={true}>
                        <CommonButton label='Assign Audit'
                            onClick={() => { handleAssignAuditClick() }}
                        />
                        <CommonButton label='Assign Verifier'
                            onClick={() => { handleAssignVerifierClick() }}
                        />
                        {auditDetailSuccess.data.status !== APP_CONSTANTS.AUDIT_STATUS.COMPLETED && state?.flowType === 'MY_AUDITS' && <CommonButton label='Add Log'
                            onClick={() => { setShowAddLogModal(true) }}
                        />}
                    </ButtonRow>}
                </CommonFormBorder>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowStatusChangeModal(false) }}
                show={showStatusChangeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Update Status
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Select Status' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedStatus}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={STATUS_LIST}
                        placeholder='Select Status'
                        onChange={e => setSelectedStatus(e)} />
                    <ButtonRow>
                        <CommonButton label='Update'
                            onClick={() => {
                                handleUpdateStatusClick()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowUpdateLogItemStatus(false) }}
                show={showUpdateLogItemStatus}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Update Status
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Select Status' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedLogStatus}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={LOG_STATUS_LIST}
                        placeholder='Select Status'
                        onChange={e => setSelectedLogStatus(e)} />
                    <ButtonRow>
                        <CommonButton label='Update'
                            onClick={() => {
                                handleUpdateLogStatusClick()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowAssignEmployeeModal(false) }}
                show={assignEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select employee
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel className='up-bold-label' label='Assignment Details' />
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { fetchEmployeeList() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(employeeListSuccess) && <div className="ae-emp-list-container">
                        {!isEmpty(employeeListSuccess.data) && employeeListSuccess.data.map(e => (<div className="ae-emp-list-item-container">
                            <div className="ae-emp-list-item-content-container">
                                <div className="ae-emp-name-label">{e.firstName} {e.lastName}</div>
                                <div className="ae-emp-code-label">{e.employeeCode}</div>
                                <div className="ae-emp-name-label">{e.role}</div>
                            </div>
                            <div className="ae-row-btn-container" onClick={() => {
                                setSelectedEmployee(e)
                            }}>Assign</div>
                        </div>))}
                    </div>}
                    {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                    <div className="td-or-label">OR</div>
                    <div className="td-or-btn-container">
                        <CommonButton label='Assign to me' onClick={() => { handleAssignEmpSubmitClick(true) }} />
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowAddLogModal(false) }}
                show={showAddLogModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Add Audit Log
                </Modal.Header>
                <Modal.Body>
                    <CommonInputFloatFull
                        type='text'
                        id='log'
                        onChange={e => setAuditLog(e.target.value)}
                        placeholder='Details'
                        value={auditLog}
                        multiline={true}
                        rows={5}
                    />
                    <div className="td-or-btn-container">
                        <CommonButton label='Submit' onClick={() => { handleAddLogSubmitClick() }} />
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AuditDetail